import styled from 'styled-components';
import Row from '@sdk/components/ui/spacing/Row';

export const CommentContent = styled(Row)`
  word-wrap: break-word;
  word-break: break-all;
  white-space: normal;
  max-width: 420px;
`;
